import { IApplicationContext } from '../../types/applicationContext';
import { makeContextModule } from '../makeContextModule';

export const { Context: ApplicationContext } = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
